import React from "react";
import { Link } from "react-router-dom";

function Instructions() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-Instructions">
      <div data-aos="fade-right" className="container d-flex flex-column align-items-start justify-content-start vh-100 w-100">
            <div className="row d-flex justify-content-center align-items-start my-auto text-center w-25">
                <div className="bg-white rounded-border py-3 border border-4 border-dark">
                    <div className="col-12 heading-font mb-3">
                        <div type="button" className="btn btn-warning rounded-pill w-100 py-3 fs-4">Instructions</div>
                    </div>
                    <strong className="text-decoration-underline">Step 1</strong>
                    <p>Choose a simulation that best represents your situation</p>
                    <strong className="text-decoration-underline">Step 2</strong>
                    <p>Run the simulation to discover insights</p>
                    <strong className="text-decoration-underline">Step 3</strong>
                    <p>Adjust the numbers to match your specifics</p>
                    <Link to={'/choose-a-simulation'} className="threeDButton btn fw-bold  w-75">
                    Got It!
                    </Link>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default Instructions;
